import api from '../../helpers/axios'
export const state = {
    section: null,
    sections: []
};

export const getters = {
    section: (state) => state.section,
    sections: (state) => state.sections,
};

export const mutations = {
    setSection(state, newValue) {
        state.section = newValue;
    },
    setSections(state, newValue) {
        state.sections = newValue;
    },
    setCourseId(state, newValue) {
        state.courseId = newValue;
    },
    setSectionId(state, newValue) {
        state.sectionId = newValue;
    },
};
export const actions = {

    createSection(_, {data, courseId}) {
        return new Promise((resolve,reject) => {
            api.post(`/courses/${courseId}/sections` , data).then((res) => {
                if(res){
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },
    updateSection(_, { sectionId,courseId, data }) {
        return new Promise((resolve, reject) => {
            api.put(`/courses/${courseId}/sections/` + sectionId, data).then((res) => {
                resolve(res.data.data);
            }).catch((err) => {
                reject(err);
            });
        });
    },
    deleteSection(_,  {courseId, sectionId }) {
        return new Promise((resolve) => {
            api.delete(`/courses/${courseId}/sections/${sectionId}`).then((res) => {
                resolve(res.data.data)
            })
        });
    },

    fetchSection({ commit }, { sectionId }) {
        return new Promise((resolve, reject) => {
            api.get("/sections/" + sectionId).then((res) => {
                commit("setSection", res.data.data);
                resolve(res.data.data);
            }).catch(err => {
                reject(err);
            });
        });
    },

    fetchSections({ commit }, { name, type,courseId, description, isActive, page, limit, listType }) {
        let query = "?";

        if (listType) {
            query += `listType=${listType}&`;
        } else {
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }

        if (name) {
            query += `name=${name}&`;
        }

        if (type) {
            query += `type=${type}&`;
        }

        if (description) {
            query += `description=${description}&`;
        }

        if (isActive !== undefined) {
            query += `isActive=${isActive}&`;
        }

        return new Promise((resolve) => {
            api.get(`/courses/${courseId}/sections` + query).then((res) => {
                commit("setSections", res.data.data);
                resolve(res.data.data);
            });
        });
    }

};
